export default __webpack_public_path__ + "static/media/unit.aa3e65f6.svg";